import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

/**
 * Optionale Konfigurationsparameter für PrimeNG Toasts.
 * Erweitert die Standardmöglichkeiten, ohne die Funktionssignaturen aufzublähen.
 */
export interface SxMessageConfig {
  /** Anzeigedauer in Millisekunden. Überschreibt den Standardwert. */
  life?: number;
  /** Wenn true, verschwindet der Toast nicht automatisch. */
  sticky?: boolean;
  /** Wenn false, wird das 'X' zum Schließen ausgeblendet. Default ist true. */
  closable?: boolean;
  /** Spezifischer Schlüssel, falls mehrere <p-toast> Elemente (z.B. an verschiedenen Positionen) existieren. */
  key?: string;
  /** Ein FontAwesome-Klassenname (z. B. 'fa-regular fa-file'), um das Standard-Icon zu überschreiben. */
  icon?: string;
  /** Eigene CSS-Klasse für das gesamte Toast-Element. */
  styleClass?: string;
  /** Eigene CSS-Klasse für den Inhaltsbereich des Toasts. */
  contentStyleClass?: string;
  /** Optionale ID für das Element. */
  id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SxMessageService {
  private messageService = inject(MessageService);

  /**
   * Zeigt eine Erfolgsmeldung an (Grün).
   */
  success(detail: string, summary: string = 'Success', config?: SxMessageConfig): void {
    this.messageService.add({
      severity: 'success',
      summary,
      detail,
      life: 3000,
      ...config
    });
  }

  /**
   * Zeigt eine Fehlermeldung an (Rot). Standardmäßig etwas länger sichtbar.
   */
  error(detail: string, summary: string = 'Error', config?: SxMessageConfig): void {
    this.messageService.add({
      severity: 'error',
      summary,
      detail,
      life: 5000,
      ...config
    });
  }

  /**
   * Zeigt eine Information an (Blau).
   */
  info(detail: string, summary: string = 'Information', config?: SxMessageConfig): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      life: 3000,
      ...config
    });
  }

  /**
   * Zeigt eine Warnung an (Gelb/Orange).
   */
  warn(detail: string, summary: string = 'Warn', config?: SxMessageConfig): void {
    this.messageService.add({
      severity: 'warn',
      summary,
      detail,
      life: 4000,
      ...config
    });
  }

  /**
   * Löscht alle aktuell sichtbaren Toasts.
   */
  clear(): void {
    this.messageService.clear();
  }
}

/**
 * Usage:
 * 
 * 
 */

/*
import { Component, inject } from '@angular/core';
import { SxMessageService } from './core/services/sx-message.service';


private sxMessageService = inject(SxMessageService);

// Fall 1: Der absolute Standardaufruf (kurz und sauber)
  showSimple() {
    this.sxMessageService.success('Daten wurden gespeichert.');
  }

  // Fall 2: Anpassung der Anzeigedauer über die Config
  showWithCustomTime() {
    this.sxMessageService.info('Dieser Hinweis verschwindet schnell.', 'Kurzinfo', {
      life: 1500
    });
  }

  // Fall 3: Ein Fehler, den der Nutzer zwingend wegklicken muss (sticky)
  // und bei dem wir das Icon austauschen
  showSticky() {
    this.sxMessageService.error(
      'Serververbindung fehlgeschlagen. Bitte Support kontaktieren.', 
      'Kritischer Fehler', 
      { 
        sticky: true,
        icon: 'fa-regular fa-bolt',
        styleClass: 'critical-error-toast' // Für individuelles CSS
      }
    );
  }

*/